import React, { useCallback, useEffect, useState } from "react";
import { Color, FontStyle, Inputs, Panels } from "../constants";
import { Box, ClickAwayListener, Fade, Stack } from "@mui/material";
import { debounce } from "../utils/utils";

const styles = {
  filtersDisplayContainer: {
    position: "absolute",
    // top: barHeight + 12,
    bottom: "-12px",
    transform: "translateY(100%)",
    left: "0",
    width: "100%",
    ...FontStyle.body,
    borderRadius: Panels.borderRadius,
    border: "1px solid #0002",
    backgroundColor: "#fff",
    boxShadow: "2px 2px 8px rgb(0 0 0 / 10%)",
    overflow: "hidden",
    paddingTop: "0px",
    paddingBottom: "0px",
    userSelect: "none",
  },
  filtersDisplay: {
    overflow: "scroll",
  },
};

const SimpleRender = ({ value }) => {
  return <Box sx={{ width: "100%", textAlign: "left" }}>{value}</Box>;
};

const OptionElement = ({
  isFirst = false,
  value,
  setValue,
  renderElement = null,
  ...props
}) => {
  const [bgColor, setBgColor] = useState("transparent");
  const selectable = value.type !== "category";
  const flash = (color) => {
    let ts = 0;
    const interval = setInterval(() => {
      ts += 1;
      if (ts === 1 || ts === 9) {
        // if (ts === 1) {
        setBgColor(color);
      } else if (ts === 7 || ts === 16) {
        // } else if (ts === 7 || ts === 16) {
        setBgColor("transparent");
      } else if (ts > 20) {
        clearInterval(interval);
      }
    }, 1000 / 60);
  };
  return (
    <Stack
      sx={{
        ...FontStyle.body,
        fontSize: "16px",
        color: "#000",
        py: "8px",
        paddingLeft: "20px",
        backgroundColor: bgColor,
        ...(!isFirst && {
          borderTop: "1px solid #0002",
        }),
        ...(selectable && {
          cursor: "pointer",
          "&:hover": {
            backgroundColor: bgColor === "transparent" ? "#eef" : bgColor,
          },
        }),
      }}
      direction="row"
      alignItems="center"
      spacing={1}
      onClick={(e) => {
        if (!selectable) return;
        e.preventDefault();
        e.stopPropagation();
        setValue(value);
        flash(Color.primaryLight);
      }}
      {...props}>
      {/* <Box>{value}</Box> */}
      {renderElement ? (
        renderElement({ value })
      ) : (
        <SimpleRender value={value} />
      )}
    </Stack>
  );
};
export const OptionsPanel = ({
  open,
  options,
  setValue,
  selectValue = null,
  renderElement = null,
}) => {
  // if an alternate "selectValue" is set, will "selectValue" the value instead of just setting it
  return (
    <Fade in={open}>
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          ...styles.filtersDisplayContainer,
          zIndex: 100,
          maxHeight: "200px",
          overflow: "scroll",
          // maxHeight: "0",
        }}>
        <Stack sx={styles.filtersDisplay} direction="column">
          {options.map((option, index) => (
            <OptionElement
              value={option}
              setValue={selectValue ? selectValue : setValue}
              key={index}
              isFirst={index === 0}
              renderElement={renderElement}
            />
          ))}
        </Stack>
      </Box>
    </Fade>
  );
};

const FettiAutocomplete = ({
  value,
  setValue,
  selectValue = null,
  options,
  setOptions,
  searchForOptions,
  searchDependencies = [],
  renderElement = null,
  searchWhenEmpty = false,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const open = focused && options.length > 0;
  useEffect(() => {
    if (!focused) return;
    if (value === "" && !searchWhenEmpty) return;
    debouncedSearchForOptions(value);
  }, [value, focused]);
  const debouncedSearchForOptions = useCallback(
    debounce((v) => {
      const newOptions = searchForOptions(v);
      if (newOptions.length > 0) {
        setOptions(newOptions);
      }
    }, 300),
    searchDependencies
  );

  return (
    <ClickAwayListener onClickAway={() => setFocused(false)}>
      <Box sx={{ width: "100%", position: "relative" }}>
        <input
          style={{
            ...FontStyle.body,
            borderRadius: Inputs.borderRadius,
            border: "1px solid #222",
            // border: "1px solid #000",
            padding: `${Inputs.py} ${Inputs.px}`,
            fontSize: "16px",
            width: "100%",
          }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setFocused(true)}
          {...props}
        />
        <OptionsPanel
          open={open}
          options={options}
          setValue={setValue}
          selectValue={
            selectValue === null
              ? null
              : (v) => {
                  setFocused(false);
                  selectValue(v);
                }
          }
          renderElement={renderElement}
        />
      </Box>
    </ClickAwayListener>
  );
};

export default FettiAutocomplete;
